import type { InjectionKey, Ref } from "vue";

const deactivateMenuSymbol = Symbol("deactivateMenu") as InjectionKey<
  Ref<boolean>
>;

export { deactivateMenuSymbol };
